import React from "react";
import LeftMenu from "./LeftMenu";
import { Link, Outlet, useNavigate } from "react-router-dom";
import "./BackendDependencies";
import { useAuth } from "../../contexts/AuthContext";
import { useEffect, useState } from "react";
import LoadingTransition from "../LoadingTransition";
import AppHeader from "./AppHeader";
import UserAvatar from "../UserAvatar";

export default function Backend() {
  // Reuse the shared user details from AuthContext (hydrated from
  // localStorage) instead of issuing a third independent Firebase fetch.
  const { userDetails, roleLoading } = useAuth();
  const currentUser = userDetails || {};
  const [isSidebarHidden, setIsSidebarHidden] = useState(false); // New state

  // Show splash only until we actually have user details (or know there
  // are none). On warm reloads with cached details this is instantaneous.
  // Cap at 1500ms so a slow network can't keep the splash forever.
  const [loading, setLoading] = useState(!userDetails);
  useEffect(() => {
    if (userDetails) {
      setLoading(false);
      return;
    }
    if (!roleLoading) {
      setLoading(false);
      return;
    }
    const loadingTimeout = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(loadingTimeout);
  }, [userDetails, roleLoading]);

  const toggleSidebar = () => {
    setIsSidebarHidden((prev) => !prev);
  };

  return (
    <>
      {loading ? (
        <LoadingTransition />
      ) : (
        <div
          className={`app align-content-stretch d-flex flex-wrap ${isSidebarHidden ? "sidebar-hidden" : ""
            }`}
        >
          <div className="app-sidebar" style={{ display: "flex", flexDirection: "column", height: "100vh", overflow: "hidden" }}>
            <div className="logo" style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", width: "100%", gap: "20px", justifyContent: "center", flexShrink: 0 }}>
              <Link to="/dashboard" className="logo-icon">
                <span className="logo-text">BBR</span>
              </Link>
              <div className="sidebar-user-switcher user-activity-online" style={{ paddingLeft: "0px", textAlign: "center", width: "auto" }}>
                <Link to="/dashboard/setting" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                  <div style={{ position: "relative", display: "inline-block" }}>
                    <UserAvatar
                      src={currentUser?.avatar}
                      name={`${currentUser?.firstName || ""} ${currentUser?.lastName || ""}`}
                      size={50}
                    />
                    <span
                      className="activity-indicator"
                      style={{
                        position: "absolute",
                        bottom: "2px",
                        right: "2px",
                        width: "12px",
                        height: "12px",
                        border: "2px solid #fff",
                        borderRadius: "50%",
                        backgroundColor: "#28a745",
                        margin: 0
                      }}
                    ></span>
                  </div>
                  <span className="user-info-text">
                    {currentUser ? currentUser.firstName : ""}
                    <br />
                    <span className="user-state-info">Online</span>
                  </span>
                </Link>
              </div>
            </div>
            <div className="app-menu overflow-auto" style={{ flex: 1, overflowY: "auto", paddingBottom: "30px" }}>
              <LeftMenu onSidebarToggle={toggleSidebar} />
            </div>
          </div>
          <div className="app-container">
            <div className="search">
              <form>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Type here..."
                  aria-label="Search"
                />
              </form>
              <a href="#" className="toggle-search">
                <i className="material-icons">close</i>
              </a>
            </div>
            <div className="app-header">
              <AppHeader onSidebarToggle={toggleSidebar} />
            </div>
            <div className="app-content">
              <div className="content-wrapper">
                <div className="container">
                  <Outlet />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
